import { useMemo } from "react"
import { useDispatch } from "react-redux"
import { Creators as NotificationCreators } from "modules/notifications/model"
import type { NotificationLevel } from "modules/notifications/types"

export function useNotifications() {
  const dispatch = useDispatch()

  // Memoised on `dispatch`, which react-redux keeps stable: an unmemoised object literal here
  // is a new reference on every render, which propagates into every `useCallback` that lists it
  // and defeats memoisation in the consumer (it was rebuilding a DataGrid's columns on every
  // render in modules/account-pats).
  return useMemo(() => ({
    show: (level: NotificationLevel, title: string | null, message: string) => {
      dispatch(NotificationCreators.add(level, title, message))
    },
    info: (message: string) => {
      dispatch(NotificationCreators.add("info", null, message))
    },
    warning: (message: string) => {
      dispatch(NotificationCreators.add("warning", null, message))
    },
    error: (message: string) => {
      dispatch(NotificationCreators.add("error", null, message))
    },
    success: (message: string) => {
      dispatch(NotificationCreators.add("success", null, message))
    },
    add: (level: NotificationLevel, title: string, message: string) => {
      dispatch(NotificationCreators.add(level, title, message))
    },
  }), [dispatch])
}
